/* eslint-disable react/prop-types */
import { UpsellBaseModal } from '../UpsellBaseModal'
import baseModalStyles from '../UpsellBaseModal/styles.module.css'
import { TabSwitcher } from '../TabSwitcher'
import { PriceComparison } from '../PriceComparison'
import { OfferBox } from '../OfferBox'
import { PackageOptionList } from '../PackageOptionList'

const TabBody = ({ content, onSelectOption }) => {
  if (!content) return null

  return (
    <>
      <PriceComparison
        marketLabel={content.marketLabel}
        marketPrice={content.marketPrice}
        platformLabel={content.platformLabel}
        platformPrice={content.platformPrice}
      />

      {content.featuredOffer && (
        <OfferBox
          variant="solid"
          label={content.featuredOffer.label}
          price={content.featuredOffer.price}
          unitPrice={content.featuredOffer.unitPrice}
          description={content.featuredOffer.description}
          subdescription={content.featuredOffer.subdescription}
        />
      )}

      {content.primaryAction && (
        <button
          type="button"
          className={baseModalStyles.primaryButton}
          onClick={content.primaryAction.onClick}
          disabled={content.primaryAction.disabled}
        >
          {content.primaryAction.label}
        </button>
      )}

      {content.otherOptions?.length > 0 && (
        <PackageOptionList
          title={content.otherOptionsTitle}
          options={content.otherOptions}
          onSelect={content.onSelectOption ?? onSelectOption}
        />
      )}
    </>
  )
}

export const CampaignReadyModal = ({
  isOpen,
  onClose,
  tabs,
  activeTab = 'packages',
  onTabChange,
  packages,
  plans,
  onSelectOption,
  showCloseButton = true,
}) => {
  const isPlansTab = activeTab === 'plans'
  const content = isPlansTab ? plans : packages

  if (!content) {
    return null
  }

  return (
    <UpsellBaseModal
      isOpen={isOpen}
      onClose={onClose}
      title={content.title}
      subtitle={content.subtitle}
      titleId="campaign-ready-modal-title"
      showCloseButton={showCloseButton}
      tertiaryAction={content.tertiaryLink}
      secondaryAction={content.skipAction}
    >
      {tabs?.length > 0 && (
        <TabSwitcher
          tabs={tabs}
          activeTab={activeTab}
          onChange={onTabChange}
        />
      )}

      <TabBody content={content} onSelectOption={onSelectOption} />
    </UpsellBaseModal>
  )
}

export default CampaignReadyModal
